import { Theme } from "@tvg/fuse/theme";
import React from "react";
import { Brand } from "types/common";
import { HeroBanner } from "./components/HeroBanner/HeroBanner";
import { InGridBanners } from "./components/InGridBanners/InGridBanners";
import { Modals } from "./components/Modals/Modals";
import { QuickFilterCarousel } from "./components/QuickFilterCarousel/QuickFilterCarousel";
import { GlobalConfigProvider } from "./context/GlobalConfig";
import { SlotConfigProvider } from "./context/SlotConfig";
import { TabConfigProvider } from "./context/TabContext";
import DevNav from "./views/DevNav";
import PLPGrid from "./views/PLPGrid";
import Tabs from "./views/Tabs";

export interface AppProps extends ClientState {
  brand: Brand;
}

const App: React.FC<AppProps> = function App({ brand, path, preconnect, slots, tabs, defaultTab }: AppProps) {
  return (
    <>
      {preconnect.map((origin) => (
        <link key={origin} data-testid="content-preconnect-link" rel="preconnect" href={origin} />
      ))}
      <DevNav path={path} />
      <Theme brand={brand} />
      <GlobalConfigProvider value={{ brand }}>
        <SlotConfigProvider value={slots} initPath={path}>
          <HeroBanner />
          <QuickFilterCarousel />
          <InGridBanners />
          <Modals />
        </SlotConfigProvider>
        <TabConfigProvider value={{ tabs, defaultTab }} initPath={path}>
          <Tabs />
        </TabConfigProvider>
      </GlobalConfigProvider>
      <PLPGrid />
    </>
  );
};

export default App;
